/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/session/session.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { SessionRoutingModule } from "./session-routing.module";
import * as i0 from "@angular/core";
export class SessionModule {
    constructor() {
    }
}
SessionModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SessionRoutingModule,
                ],
            },] },
];
/** @nocollapse */
SessionModule.ctorParameters = () => [];
/** @nocollapse */ SessionModule.ɵmod = i0.ɵɵdefineNgModule({ type: SessionModule });
/** @nocollapse */ SessionModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SessionModule_Factory(t) { return new (t || SessionModule)(); }, imports: [[
            SessionRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SessionModule, { imports: [SessionRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SessionModule, [{
        type: NgModule,
        args: [{
                imports: [
                    SessionRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Vzc2lvbi5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9zZXNzaW9uL3Nlc3Npb24ubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMsb0JBQW9CLEVBQUMsTUFBTSwwQkFBMEIsQ0FBQzs7QUFPOUQsTUFBTSxPQUFPLGFBQWE7SUFDeEI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixvQkFBb0I7aUJBQ3JCO2FBQ0Y7Ozs7aURBQ1ksYUFBYTt5R0FBYixhQUFhLGtCQUpkO1lBQ1Isb0JBQW9CO1NBQ3JCO3dGQUVVLGFBQWEsY0FIdEIsb0JBQW9CO2tEQUdYLGFBQWE7Y0FMekIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixvQkFBb0I7aUJBQ3JCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtTZXNzaW9uUm91dGluZ01vZHVsZX0gZnJvbSBcIi4vc2Vzc2lvbi1yb3V0aW5nLm1vZHVsZVwiO1xuXG5ATmdNb2R1bGUoe1xuICBpbXBvcnRzIDogW1xuICAgIFNlc3Npb25Sb3V0aW5nTW9kdWxlLFxuICBdLFxufSlcbmV4cG9ydCBjbGFzcyBTZXNzaW9uTW9kdWxlIHtcbiAgY29uc3RydWN0b3IoKSB7fVxufVxuIl19